export default "__VITE_ASSET__70f8736b__"